import { Component, OnInit } from '@angular/core';
import { LeaderboardType, ScreenSizeService } from '@fgb/core';

@Component({
  selector: 'fgb-trivia-v2-leaderboard-page',
  templateUrl: './trivia-v2-leaderboard-page.component.html',
  styleUrl: './trivia-v2-leaderboard-page.component.scss',
})
export class TriviaV2LeaderboardPageComponent implements OnInit {
  LeaderboardType: LeaderboardType = LeaderboardType.TriviaEntries;
  screenSize: number = 0;
  constructor(private screenSizeServices: ScreenSizeService) {}
  ngOnInit() {
    this.screenSizeServices.selectScreenWidth().subscribe((size: number) => (this.screenSize = size));
  }
}
